// Author Liang Gang Qiang
// Date 2021-11-26 16:32:46

class MintalMesQualityProjectItem {
constructor({
        id = null,
        qualityProjectId = '',
        qualityProjectName = '',
        compoundId = '',
        upperLimit = '',
        lowerLimit = '',
        middleLimit = '',
        ifIsTopGrade = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.qualityProjectId = qualityProjectId;
    this.qualityProjectName = qualityProjectName;
    this.compoundId = compoundId;
    this.upperLimit = upperLimit;
    this.lowerLimit = lowerLimit;
    this.middleLimit = middleLimit;
    this.ifIsTopGrade = ifIsTopGrade;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesQualityProjectItem();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualityProjectName',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.qualityProjectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'compoundFormula',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.compoundFormula',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'compoundName',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.compoundName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'upperLimit',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.upperLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'lowerLimit',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.lowerLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'middleLimit',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.middleLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ifIsTopGrade',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.ifIsTopGrade',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '≥' },
                            { value: '2', text: '≤' }
            ]
        }
        },
        {
        key: 'compoundUnit',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.compoundUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    qualityProjectIdFilter : '',
    qualityProjectNameFilter : '',
    projectCodeFilter : '',
    compoundIdFilter : '',
    upperLimitFilter : '',
    lowerLimitFilter : '',
    middleLimitFilter : '',
    ifIsTopGradeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'qualityProjectNameFilter',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.filter.qualityProjectName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProject'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"qualityProjectId": "id"}'
                }
        },
        {
        key: 'compoundIdFilter',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.filter.compoundId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesQualityCompound'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'upperLimitFilter',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.filter.upperLimit',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'lowerLimitFilter',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.filter.lowerLimit',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'middleLimitFilter',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.filter.middleLimit',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ifIsTopGradeFilter',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.filter.ifIsTopGrade',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '≥' },
                { value: '2', text: '≤' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'qualityProjectName',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.entity.qualityProjectName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProject'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"qualityProjectId": "id"}'
                }
        },
        {
        key: 'compoundId',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.entity.compoundId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesQualityCompound'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'upperLimit',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.entity.upperLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'lowerLimit',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.entity.lowerLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'middleLimit',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.entity.middleLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ifIsTopGrade',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.entity.ifIsTopGrade',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '≥' },
                { value: '2', text: '≤' }
            ]
        }
        },
        {
        key: 'seq',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProjectItem.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesQualityProjectItem, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
